const ROUND_LABELS = {
    'final': 'Finale',
    'semi-final': 'Demi-finales',
    'quarter-final': 'Quarts de finale',
    'round of 16': 'Huitièmes de finale',
    'round of 32': 'Seizièmes de finale',
    'round of 64': 'Trente-deuxièmes de finale',
    'round of 128': 'Soixante-quatrièmes de finale',
}

export const formatRoundLabel = (day) => {
    const normalizedDay = String(day).trim().toLowerCase()

    if (ROUND_LABELS[normalizedDay]) {
        return ROUND_LABELS[normalizedDay]
    }

    const numericDay = Number(day)

    if (Number.isInteger(numericDay)) {
        return `${numericDay}${numericDay === 1 ? 're' : 'e'} journée`
    }

    return String(day)
}